import HOOK from "../hooks"
import { CHECKBOX } from "../../modules/checkbox_constants"
import { BASE, CATEGORY, COMPANY_STATUS, KIND, TAB, TENSE_ENUM } from "../../modules/constants"
import { INDEX } from "../../modules/indexConstants"
import { getChecked } from "../../pages/companiesHouse/pageFunctions/checkboxFunctions"
import { filterAdvisersByCheckbox } from "./FilterAdviserSearchResults"

var favouriteChecked
const audCom = 0
const remCom = 1
const nomCom = 2
const chair = 0
const member = 1

const filterRows = ({ items, checkboxes, filter, searchResults, tabIndex }) => {
  // console.log("items: ", items)
  if (filter)
    items = filterBySearch(items, filter.toUpperCase(), tabIndex)

  // Add totalResults - the number of items filtered by search, but not by checkboxes
  searchResults.totalResults = items.length
  return filterByCheckbox(items, checkboxes, searchResults.kind)
}

// Filter by search string - 'filter'
const filterBySearch = (items, filter, tabIndex) => {
  var epicMatch = []
  var fullMatch = []

  switch (tabIndex) {

    case TAB[BASE.LSE.PEOPLE].INDEX:
    case TAB[BASE.LSE.ROLES].INDEX:

      const split = filter.split(' ')

      split.forEach(element => {
        items = items.filter(i => (i.commonInfo.name.toUpperCase().indexOf(element) > -1))
      })
      return items

    case TAB[BASE.LSE.COMPANIES].INDEX:
      // console.log('items:',items)
      // Filter items with full epic match
      epicMatch = items.filter(i => i.epics.find(e => e === filter))

      // Filter remaining items
      if (epicMatch.length > 0)
        items = items.filter(i => i.index !== epicMatch[0].index)

      // Filter remaining items with full name match
      fullMatch = items.filter(i => getCompanyName(i) === filter)
      if (fullMatch.length > 0)
        items = items.filter(i => i.index !== fullMatch[0].index)

      // Filter remaining items with partial epic or name
      items = items.filter(
        i => (!!i.epics.filter(epic => epic.includes(filter)).length || !!i.names?.filter(name => name?.includes(filter)).length)
      )

      items = epicMatch.concat(fullMatch).concat(items)

      return items

    case TAB[BASE.LSE.ADVISERS].INDEX:
      // console.log('items:', items)
      filter = filter.toUpperCase()
      // Filter items by name.includes
      return items.filter(i => i.name?.toUpperCase().includes(filter))

    case TAB[BASE.LSE.NEWS].INDEX:
      // Filter items with full epic match
      epicMatch = items.filter(i => i.epics.find(e => e === filter))

      /*
      Filter out any items with in index that matches one in the epicMatch array. Eg:
      const epicMatch = [{index: 1}, {index:4}]
      var items =[ {index:1}, {index:2}, {index:3}, {index:4} ]
      items = items.filter(i => epicMatch.every(e => e.index !== i.index))
      console.log(items)
      */
      if (epicMatch.length > 0)
        items = items.filter(i => epicMatch.every(e => e.index !== i.index))

      // Filter remaining items with full company match
      fullMatch = items.filter(i => i.company === filter)
      if (fullMatch.length > 0)
        items = items.filter(i => i.company !== filter)

      // Filter remaining items with partial companyName or epic match
      items = items.filter(i => !!i.epics.filter(epic => epic.includes(filter)).length || (i.company.indexOf(filter) > -1))

      items = epicMatch.concat(fullMatch).concat(items)

      return items

    default:
      return items
  }
}

// i.companyName will be replaced by array i.names[0]
const getCompanyName = i => i.companyName ?? i.names[0]

const getCmteChecked = checkboxes => ([
  [!!(CHECKBOX[HOOK.COMMITTEE][0].BIT & checkboxes[HOOK.COMMITTEE]),  // [0, 0] Audit chair
  !!(CHECKBOX[HOOK.COMMITTEE][1].BIT & checkboxes[HOOK.COMMITTEE])],  // [0, 1] Audit member
  [!!(CHECKBOX[HOOK.COMMITTEE][2].BIT & checkboxes[HOOK.COMMITTEE]),  // [1, 0] Remuneration chair
  !!(CHECKBOX[HOOK.COMMITTEE][3].BIT & checkboxes[HOOK.COMMITTEE])],  // [1, 1] Remuneration member
  [!!(CHECKBOX[HOOK.COMMITTEE][4].BIT & checkboxes[HOOK.COMMITTEE]),  // [2, 0] Nomination chair
  !!(CHECKBOX[HOOK.COMMITTEE][5].BIT & checkboxes[HOOK.COMMITTEE])],  // [2, 1] Nomination member
  [!!(CHECKBOX[HOOK.COMMITTEE][6].BIT & checkboxes[HOOK.COMMITTEE])], // [3, 0] Non-members
])

const filterByCheckbox = (items, checkboxes, kind) => {
  favouriteChecked = getChecked({ checkboxes, hook: HOOK.FAVOURITE })[0]

  switch (kind) {
    case KIND.LSE.COMPANIES.OVERVIEW:
    case KIND.LSE.COMPANIES.BOARD:
    case KIND.LSE.COMPANIES.GOVERNANCE:
    case KIND.LSE.COMPANIES.DATES:
    case KIND.LSE.COMPANIES.ADVISERS:
      return filterCompaniesByCheckbox({ items, checkboxes })

    case KIND.LSE.COMPANIES.COMMITTEES:
      items = filterCompaniesByCheckbox({ items, checkboxes })
      return filterCompaniesByCommitteesCheckbox({ items, checkboxes })

    case KIND.LSE.ROLES.BOARD:
    case KIND.LSE.ROLES.COMMITTEES:
      return filterRolesByCheckbox({ checkboxes, items, kind })

    case KIND.LSE.PEOPLE.BOARD:
      return filterPeopleBoardByCheckbox({ items, checkboxes })

    case KIND.LSE.PEOPLE.COMMITTEES:
      return filterPeopleCommitteesByCheckbox({ items, checkboxes })

    case KIND.LSE.NEWS:
      return filterNewsByCheckbox({ items, checkboxes, favouriteChecked, nexus: false })

    case KIND.LSE.ADVISERS:
      return filterAdvisersByCheckbox({ items, checkboxes })

    case KIND.SEARCH.COMPANIES: //???
    default:
      return items.length && items[0].kind === KIND.SEARCH.RESULTS.OFFICER
        ? filterOfficerSearchByCheckbox({ items, checkboxes })
        : filterCompanySearchByCheckbox({ items, checkboxes })
  }
}

const ltd = "Limited Company"
const plc = "Public Limited Company"

const filterCompanySearchByCheckbox = ({ items, checkboxes }) => {
  // console.log('filterCompanySearchByCheckbox: items', items)

  //#region Company Status
  // If not checked, remove 'active' items
  items = !!!(CHECKBOX[HOOK.COMPANY_SEARCH][0].BIT & checkboxes[HOOK.COMPANY_SEARCH])
    ? items.filter(i => i.companyStatus !== COMPANY_STATUS.ACTIVE) : items

  // If not checked, remove 'dissolved' items
  items = !!!(CHECKBOX[HOOK.COMPANY_SEARCH][1].BIT & checkboxes[HOOK.COMPANY_SEARCH])
    ? items.filter(i => i.companyStatus !== COMPANY_STATUS.DISSOLVED) : items

  // It 'other' not checked, only select 'active' and 'dissolved' items
  items = !!!(CHECKBOX[HOOK.COMPANY_SEARCH][2].BIT & checkboxes[HOOK.COMPANY_SEARCH])
    ? items.filter(i => i.companyStatus === COMPANY_STATUS.ACTIVE || i.companyStatus === COMPANY_STATUS.DISSOLVED) : items
  //#endregion

  //#region Company type
  // If not checked, remove 'ltd' items
  items = !!!(CHECKBOX[HOOK.COMPANY_REG_TYPE][0].BIT & checkboxes[HOOK.COMPANY_REG_TYPE])
    ? items.filter(i => i.companyType !== ltd) : items

  // If not checked, remove 'plc' items
  items = !!!(CHECKBOX[HOOK.COMPANY_REG_TYPE][1].BIT & checkboxes[HOOK.COMPANY_REG_TYPE])
    ? items.filter(i => i.companyType !== plc) : items

  // It 'other' not checked, only select 'ltd' and 'plc' items
  items = !!!(CHECKBOX[HOOK.COMPANY_REG_TYPE][2].BIT & checkboxes[HOOK.COMPANY_REG_TYPE])
    ? items.filter(i => i.companyType === ltd || i.companyType === plc) : items
  //#endregion

  return items
}

const filterOfficerSearchByCheckbox = ({ items, checkboxes }) => {
  // console.log('filterOfficersByCheckbox: items', items)

  // Exclude corporate
  if (!!!(CHECKBOX[HOOK.OFFICER_SEARCH][0].BIT & checkboxes[HOOK.OFFICER_SEARCH]))
    items = items.filter(i => i.category === CATEGORY.PERSON)

  // Exclude zero roles
  if (!!!(CHECKBOX[HOOK.OFFICER_SEARCH][1].BIT & checkboxes[HOOK.OFFICER_SEARCH]))
    items = items.filter(i => i.appointmentCount > 0)

  return items
}

// Filter the companies by industry, country, aic and index checkboxes
// NB: each it can be one of each type - eg is in FTSE 250 - or is or isn't - eg aic is true or false
const filterCompaniesByCheckbox = ({ items, checkboxes }) => {
  return items
    .filter(i => i.industryBit & checkboxes[HOOK.INDUSTRY])

    // Either British and CHECKBOX[HOOK.COUNTRY][0] set, or not Brish and CHECKBOX[HOOK.COUNTRY][1] set.
    .filter(i => (i.countryCode === "GB" && CHECKBOX[HOOK.COUNTRY][0].BIT & checkboxes[HOOK.COUNTRY]) ||
      (i.countryCode !== "GB" && CHECKBOX[HOOK.COUNTRY][1].BIT & checkboxes[HOOK.COUNTRY]))

    // aic and CHECKBOX[HOOK.COMPANY_TYPE][COMPANY_TYPE.INVEST] set or
    // not aic and CHECKBOX[HOOK.COMPANY_TYPE][COMPANY_TYPE.TRADE] set
    .filter(i => (!i.aic && CHECKBOX[HOOK.COMPANY_TYPE][INDEX.CO_TYPE.TRADE].BIT & checkboxes[HOOK.COMPANY_TYPE]) ||
      (i.aic && CHECKBOX[HOOK.COMPANY_TYPE][INDEX.CO_TYPE.INVEST].BIT & checkboxes[HOOK.COMPANY_TYPE]))

    .filter(i => (i.indexBit & checkboxes[HOOK.LSE_INDEX]) || (i.isFavourite && favouriteChecked))
}

// Filter companies by the committees checkboxes
const filterCompaniesByCommitteesCheckbox = ({ items, checkboxes }) => {
  const cmteChecked = getCmteChecked(checkboxes)
  const filteredItems = []

  // cmtes[n][chair] is usually 1 - or -1 if there is no committee
  // cmtes[n][member] is usually 1 or more - or -1 if there is no committee
  items.forEach(item => {
    const { cmtes } = item
    if (((cmtes[audCom][chair] > 0 && cmteChecked[audCom][chair]) // Audit chair
      || (cmtes[audCom][member] > 0 && cmteChecked[audCom][member]) // Audit member
      || (cmtes[remCom][chair] > 0 && cmteChecked[remCom][chair]) // Remuneration chair
      || (cmtes[remCom][member] > 0 && cmteChecked[remCom][member]) // Remuneration member
      || (cmtes[nomCom][chair] > 0 && cmteChecked[nomCom][chair]) // Nomination chair
      || (cmtes[nomCom][member] > 0 && cmteChecked[nomCom][member]) // Nomination member
      || (cmteChecked[3][0]
        && cmtes[audCom][chair] < 1
        && cmtes[audCom][member] < 1
        && cmtes[remCom][chair] < 1
        && cmtes[remCom][member] < 1
        && cmtes[nomCom][chair] < 1
        && cmtes[nomCom][member] < 1)
    ))
      filteredItems.push(item)
  })

  return filteredItems
}

//#region filterRolesByCheckbox
const filterRolesByCheckbox = ({ checkboxes, items, kind }) => {
  let filteredItems = []
  const tenseArray = getTenseArray({ checkboxes, kind })
  const cmteChecked = getCmteChecked(checkboxes)

  items.forEach(item => {
    const { committees, companyInfo, apptInfo, personInfo } = item
    const positionCheckbox = CHECKBOX[HOOK.POSITION][apptInfo.position.type]

    const sexCheckbox = (personInfo.sex === 0 || personInfo.sex === 1)
      ? CHECKBOX[HOOK.SEX][personInfo.sex] : CHECKBOX[HOOK.SEX][2]

    const execCheckbox = (apptInfo.position.exec === 0 || apptInfo.position.exec === 1)
      ? CHECKBOX[HOOK.EXEC][apptInfo.position.exec] : CHECKBOX[HOOK.EXEC][2]

    const indpCheckbox = (apptInfo.position.indp === 0 || apptInfo.position.indp === 1)
      ? CHECKBOX[HOOK.INDP][apptInfo.position.indp] : CHECKBOX[HOOK.INDP][2]

    if (
      // If industryBit checkbox is selected ...
      !!(companyInfo.industryBit & checkboxes[HOOK.INDUSTRY])

      //.. and CountryCode checkbox matches
      && ((companyInfo.countryCode === "GB" && (CHECKBOX[HOOK.COUNTRY][0].BIT & checkboxes[HOOK.COUNTRY])) ||
        (companyInfo.countryCode !== "GB" && (CHECKBOX[HOOK.COUNTRY][1].BIT & checkboxes[HOOK.COUNTRY])))

      // .. and company type checkbox matches
      && ((!companyInfo.aic && (CHECKBOX[HOOK.COMPANY_TYPE][INDEX.CO_TYPE.TRADE].BIT & checkboxes[HOOK.COMPANY_TYPE])) ||
        (companyInfo.aic && (CHECKBOX[HOOK.COMPANY_TYPE][INDEX.CO_TYPE.INVEST].BIT & checkboxes[HOOK.COMPANY_TYPE])))

      // ..and index is selected
      && !!(companyInfo.indexBit & checkboxes[HOOK.LSE_INDEX])

      // ..and position checkbox is selected
      && !!(positionCheckbox.BIT & checkboxes[HOOK.POSITION])

      // ..and sex checkbox is selected
      && sexCheckbox && !!(sexCheckbox.BIT & checkboxes[HOOK.SEX])

      // ..and exec checkbox is selected
      && execCheckbox && !!(execCheckbox.BIT & checkboxes[HOOK.EXEC])

      // ..and independent checkbox is selected
      && indpCheckbox && !!(indpCheckbox.BIT & checkboxes[HOOK.INDP])

      // ..and tense is selected
      && tenseArray.includes(apptInfo.tense)

      // filter by committee membership
      && (kind === KIND.LSE.ROLES.COMMITTEES
        && ((committees === null && cmteChecked[3][0])             // Non-members
          || (committees?.a === 1 && cmteChecked[audCom][chair])   // Audit chair
          || (committees?.a === 2 && cmteChecked[audCom][member])  // Audit member
          || (committees?.r === 1 && cmteChecked[remCom][chair])   // Remuneration chair
          || (committees?.r === 2 && cmteChecked[remCom][member])  // Remuneration member
          || (committees?.n === 1 && cmteChecked[nomCom][chair])   // Nomination chair
          || (committees?.n === 2 && cmteChecked[nomCom][member])) // Nomination member
        || kind === KIND.LSE.ROLES.BOARD)
    )
      filteredItems.push(item)
  })
  return filteredItems
}

const getTenseArray = ({ checkboxes, kind }) => {
  // Returns an array corresponding to the checked tense checkboxes
  // eg [0, 1] if 'current' and 'notice' are checked

  if (kind === KIND.LSE.ROLES.COMMITTEES)
    return [TENSE_ENUM.CURRENT, TENSE_ENUM.NOTICE]
  else {
    const array = []

    CHECKBOX[HOOK.TENSE].forEach((element, index) => {
      if (!!(element.BIT & checkboxes[HOOK.TENSE]))
        array.push(index)
    })

    return array
  }
}
//#endregion filterApptsByCheckbox

//#region filterPeopleByCheckbox
const filterPeopleBoardByCheckbox = ({ checkboxes, items }) => {
  const filteredItems = []
  const checked = {
    // Committees are always filtered by current and outgoing tense
    tense: getChecked({ checkboxes, hook: HOOK.TENSE }),
    sex: getChecked({ checkboxes, hook: [HOOK.SEX] }),
    index: getChecked({ checkboxes, hook: [HOOK.LSE_INDEX] }),
    companyType: getChecked({ checkboxes, hook: [HOOK.COMPANY_TYPE] }),
  }

  items.forEach(item => {
    if (itemMatchesCheckboxes(item, checked))
      filteredItems.push(item)
  })

  return filteredItems
}

const filterPeopleCommitteesByCheckbox = ({ checkboxes, items }) => {
  const filteredItems = []
  const checked = {
    // Committees are always filtered by current and outgoing tense
    tense: [true, true, false, false],
    sex: getChecked({ checkboxes, hook: [HOOK.SEX] }),
    index: getChecked({ checkboxes, hook: [HOOK.LSE_INDEX] }),
    companyType: getChecked({ checkboxes, hook: [HOOK.COMPANY_TYPE] }),
  }
  const cmteChecked = getCmteChecked(checkboxes)

  items.forEach(item => {
    const { cmteStats } = item
    if (itemMatchesCheckboxes(item, checked)
      && ((cmteStats[audCom][chair] && cmteChecked[audCom][chair]) // Audit chair
        || (cmteStats[audCom][member] && cmteChecked[audCom][member]) // Audit member
        || (cmteStats[remCom][chair] && cmteChecked[remCom][chair]) // Remuneration chair
        || (cmteStats[remCom][member] && cmteChecked[remCom][member]) // Remuneration member
        || (cmteStats[nomCom][chair] && cmteChecked[nomCom][chair]) // Nomination chair
        || (cmteStats[nomCom][member] && cmteChecked[nomCom][member]) // Nomination member
        || (cmteChecked[3][0]
          && !cmteStats[audCom][chair]
          && !cmteStats[audCom][member]
          && !cmteStats[remCom][chair]
          && !cmteStats[remCom][member]
          && !cmteStats[nomCom][chair]
          && !cmteStats[nomCom][member])
      )
    )
      filteredItems.push(item)
  })

  return filteredItems
}

const matchIndexAndTense = ({ checked, counts, aicCounts }) => {
  // loop past, present & future
  for (let t = 0; t < counts.length; t++)
    // loop lse 100, 250, etc
    for (let i = 0; i < counts[t].length; i++)
      if (checked.tense[t] === true &&
        checked.index[i] === true &&
        ((counts[t][i] > 0 && checked.companyType[0] === true) || (aicCounts[t][i] > 0 && checked.companyType[1] === true)))
        return true

  return false
}

const matchSex = (checked, personInfo) => {
  return personInfo.sex == null
    ? checked.sex[2] === true
    : checked.sex[personInfo.sex] === true
}

const itemMatchesCheckboxes = (item, checked) => {
  const { apptStats, personInfo } = item
  const { aicCounts, counts } = apptStats
  return matchIndexAndTense({ checked, counts, aicCounts }) && matchSex(checked, personInfo)
}
//#endregion filterPeopleByCheckbox

//#region filter News
export const filterNewsByCheckbox = ({ items, checkboxes, favouriteChecked, nexus }) => {
  // if 'nexus' we don't want to filter by index checkboxes because we must show news for that company regardless
  return items
    .filter(i => (nexus || (i.indexBit & checkboxes[HOOK.LSE_INDEX]) || (i.favourite && favouriteChecked)))
    .filter(i => (!i.aic && (CHECKBOX[HOOK.COMPANY_TYPE][INDEX.CO_TYPE.TRADE].BIT & checkboxes[HOOK.COMPANY_TYPE])) ||
      (i.aic && (CHECKBOX[HOOK.COMPANY_TYPE][INDEX.CO_TYPE.INVEST].BIT & checkboxes[HOOK.COMPANY_TYPE])))
    .filter(i => !!(i.category & checkboxes[HOOK.NEWS_CATEGORY]))
}
//#endregion

//#region dashboard
export const filterAdviserClientsByCheckbox = ({ items, checkboxes }) => {
  favouriteChecked = getChecked({ checkboxes, hook: HOOK.FAVOURITE })[0]
  return filterCompaniesByCheckbox({ items, checkboxes })
}

export const filterListingChangesByCheckbox = ({ items, checkboxes, delistedChecked, favouriteChecked }) => {
  return items
    // Is not longer in index, is in a checked index or is a favourite
    .filter(i => ((!i.indexBit && delistedChecked) || (i.indexBit & checkboxes[HOOK.LSE_INDEX]) || (i.previousIndexBit & checkboxes[HOOK.LSE_INDEX]) || (i.favourite && favouriteChecked)))
    .filter(i => (!i.aic && (CHECKBOX[HOOK.COMPANY_TYPE][INDEX.CO_TYPE.TRADE].BIT & checkboxes[HOOK.COMPANY_TYPE])) ||
      (i.aic && (CHECKBOX[HOOK.COMPANY_TYPE][INDEX.CO_TYPE.INVEST].BIT & checkboxes[HOOK.COMPANY_TYPE])))
}

export const filterApptsByCheckbox = ({ checkboxes, favouriteChecked, items }) => {
  // console.log('filterApptsByCheckbox items:', items)
  return items
    .filter(i => (i.companyInfo.indexBit & checkboxes[HOOK.LSE_INDEX]) || (i.favourite && favouriteChecked) || !i.companyInfo.indexBit)
    .filter(i => (!i.companyInfo.aic && (CHECKBOX[HOOK.COMPANY_TYPE][INDEX.CO_TYPE.TRADE].BIT & checkboxes[HOOK.COMPANY_TYPE])) ||
      (i.companyInfo.aic && (CHECKBOX[HOOK.COMPANY_TYPE][INDEX.CO_TYPE.INVEST].BIT & checkboxes[HOOK.COMPANY_TYPE])))
}

export const filterAnnualReportsByCheckbox = ({ checkboxes, favouriteChecked, items }) => {
  return items
    .filter(i => (i.indexBit & checkboxes[HOOK.LSE_INDEX]) || (i.isFavourite && favouriteChecked))
    .filter(i => (!i.aic && (CHECKBOX[HOOK.COMPANY_TYPE][INDEX.CO_TYPE.TRADE].BIT & checkboxes[HOOK.COMPANY_TYPE])) ||
      (i.aic && (CHECKBOX[HOOK.COMPANY_TYPE][INDEX.CO_TYPE.INVEST].BIT & checkboxes[HOOK.COMPANY_TYPE])))
}
//#endregion

export default filterRows